<div style="padding: 0;border: 1px solid #c3bdbd;margin: 0 10px;  background: #f9f9f9;">
    <div style="text-align:center;border: 1px solid #c3bdbd;font-weight: 600;">

        Guidelines to choose the Overall rating of a Resume
        <span (click)="close()" style="    float: right;cursor: pointer;background: red;color: #ffffff;padding: 0 8px;text-align: center;">
            X
        </span>

    </div>
    <div style="color:red;font-size:14px;padding:0 10px;">
        <p>It is highly important to rate the Resume to correct level where it matches. If you rate it higher, then Jobseeker
            may fail in almost all matching jobs, if you rate Low, then also Jobseeker reject most of the jobs. Hence is
            super critical rate the Resume perfectly where it matches without any bias. Note: Rating high is more dangerous
            than rating low.
        </p>
    </div>
    <div>
        <table style="font-size:12px">
            <thead style="color:#ffffff">
                <tr style="border:1px solid #ffffff; background: #737fc5;height: 25px;
                ">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center;">Rating</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">Guidelines</td>
                </tr>

            </thead>
            <tbody>
                <tr style="height: 25px;background:#cdcbff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">1*</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">A fresher or experienced, working in a small or moderate company and studied in a moderate University
                        (Entry level profile)
                    </td>
                </tr>
                <tr style="height: 25px;background:#e2e1ff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">2*</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">A fresher or experienced, working in medium to large company and studied in a good University(Moderate
                        profile)

                    </td>
                </tr>
                <tr style="height: 25px;background:#cdcbff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">3*</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">A fresher or experienced, working in a well known company and studied in a well known University(Good
                        profile)

                    </td>
                </tr>
                <tr style="height: 25px;background:#e2e1ff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">4*</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">A fresher or experienced, working in a highly familiar/MNC company and studied in one of the best University(Excellent/High
                        profile)

                    </td>
                </tr>
                <tr style="height: 25px;background:#cdcbff">
                    <td style="width: 10%;border:1px solid #ffffff;text-align:center">5*</td>
                    <td style="border:1px solid #ffffff;padding: 3px 10px;">A fresher or experienced, working in Global Fortune 100 companies and studied in the premium University(Most
                        premium profile)

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div style="text-align:center;">
        <button (click)="close()" style="color: #fff;background: red;padding: 5px 20px;">OK, Got it</button>
    </div>

</div>